export default __webpack_public_path__ + "static/GilroyRegular-53b4145b7634c2780a579c08f7483053.woff";